import { sortBy } from 'lodash';

export function filterAndSort<T extends { id?: number | string; name?: string }>(items: T[], term: string): T[] {
  term = term.toLowerCase();
  const filtered = items.filter((i) => i.name?.toLowerCase().includes(term) || i.id?.toString().includes(term));
  return sortBy(filtered, (i) => i.name?.toLowerCase().trim());
}

export function customSearchForIdAndName<T extends { id?: number | string; name?: string; external_id?: string }>(
  term: string,
  item: T,
): boolean {
  term = term.toLowerCase();

  return (
    item.name?.toLowerCase().includes(term) ||
    item.id?.toString().toLowerCase().includes(term) ||
    !!item.external_id?.toLowerCase().includes(term)
  );
}
